import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';
import { Settings } from '../model/settings.model';
@Injectable()
export class SettingsService {

  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) { }

  getSettingsList() {
    return this.httpClient.get(`${this.rootUrl}/api/Settings/GetSettings`);
  }

  settingsSet(setting: Settings) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/Settings/SettingsSet`, setting, { headers });
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/settings.service.ts